export const NOTIFICATION_TYPES = {
  project_forum_post: 'New Forum Post',
  project_forum_reply: 'New Forum Reply',
  project_observation: 'New Observation',
  project_resource: 'New Project Resource',
  project_download: 'Project Data Download'
}
